import { useQuery } from 'react-query';
import { getWorkAgreementDetails } from 'RestAPIs/employees/work-agreements';

const useGetWorkAgreementDetails = (employeeId: number) => {
  const { data, isFetching, isError, refetch } = useQuery(
    ['workAgreementDetails', employeeId],
    async () => {
      const { data } = await getWorkAgreementDetails({ employeeId });
      return data;
    },
    { staleTime: 5 * 60 * 1000 }
  );
  return { data, isFetching, isError, refetch };
};

export default useGetWorkAgreementDetails;
